import { useState } from "react";
import { motion } from "framer-motion";
import { Plane, Menu, X } from "lucide-react";

const links = [
  { id: "storia", label: "La Nostra Rotta" },
  { id: "luogo", label: "Il Luogo" },
  { id: "lista-nozze", label: "Lista Nozze" },
  { id: "gallery", label: "Gallery" },
];

export default function Navbar({ onNavigate }) {
  const [open, setOpen] = useState(false);
  const go = (id) => {
    setOpen(false);
    onNavigate(id);
  };

  return (
    <motion.header
      initial={{ y: -90 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: 0.1 }}
      className="fixed top-0 inset-x-0 z-50 bg-panna/85 backdrop-blur-xl border-b border-sand/70"
      data-testid="main-nav"
    >
      <div className="mx-auto max-w-7xl px-6 sm:px-12 lg:px-24 h-16 flex items-center justify-between">
        <button
          onClick={() => go("top")}
          className="flex items-center gap-2 group"
          data-testid="nav-logo"
        >
          <Plane className="w-4 h-4 text-terracotta transition-transform duration-500 group-hover:rotate-45" />
          <span className="font-serif text-lg tracking-tight">F &amp; A</span>
        </button>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => go(l.id)}
              className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#5C564E] hover:text-terracotta transition-colors duration-300"
              data-testid={`nav-link-${l.id}`}
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            onClick={() => go("rsvp")}
            className="hidden sm:inline-flex rounded-full bg-terracotta text-panna font-mono text-[11px] uppercase tracking-[0.2em] px-5 py-2.5 transition-all duration-300 hover:bg-[#b25c42] hover:scale-[1.03]"
            data-testid="nav-rsvp-button"
          >
            Conferma
          </button>
          <button
            className="lg:hidden p-2 text-[#2D2A26]"
            onClick={() => setOpen(!open)}
            aria-label="Menu"
            data-testid="nav-menu-toggle"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-sand/70 bg-panna/95 backdrop-blur-xl px-6 py-6 flex flex-col gap-5" data-testid="nav-mobile-menu">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => go(l.id)}
              className="text-left font-mono text-xs uppercase tracking-[0.25em] text-[#5C564E]"
              data-testid={`nav-mobile-link-${l.id}`}
            >
              {l.label}
            </button>
          ))}
          <button
            onClick={() => go("rsvp")}
            className="text-left font-mono text-xs uppercase tracking-[0.25em] text-terracotta"
            data-testid="nav-mobile-rsvp-button"
          >
            Conferma la tua presenza
          </button>
        </div>
      )}
    </motion.header>
  );
}
